import { Cable } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "../shadcn/button";

export const MobileWarningBanner = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    const hasAccepted = localStorage.getItem("acceptedMobileWarning");
    if (hasAccepted) {
      setShowBanner(false);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("acceptedMobileWarning", "true");
    setShowBanner(false);
  };

  if (!isMounted || !showBanner) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bottom-0 bg-background z-9999 p-4 block md:hidden">
      <div className="flex flex-col h-full w-full items-center justify-center gap-8 px-8">
        <div className="flex flex-col items-center justify-center gap-2">
          <Cable size="2rem" color="#69696B" />
          <h2 className="text-center text-lg font-semibold">
            Desktop Experience Recommended
          </h2>
          <p className="text-center text-sm max-w-160">
            For the best experience and full functionality, we recommend using
            Noxus on a desktop or laptop computer.
          </p>
        </div>
        <Button onClick={handleAccept}>Continue on this device</Button>
      </div>
    </div>
  );
};
